import { Component, Input, OnInit } from '@angular/core';
import { StatusBag } from '@app/enums';

/**
 * Componente para mostrar el estado de una maleta.
 *
 */
@Component({
    selector: 'am-bag-status',
    templateUrl: './am-bag-status.component.html',
    styleUrls: ['./am-bag-status.component.scss'],
    standalone: false
})
export class AmBagStatusComponent implements OnInit {

/**
   * Estado de la maleta. Este valor es de tipo `StatusBag` y se pasa como input desde el componente padre.
   * 
   * @type {StatusBag}
   */
@Input() statusBag: StatusBag;

/**
 * Monto total asociado con la maleta. Este valor es un número y se pasa como input desde el componente padre.
 * 
 * @type {number}
 */
@Input() totalAmount: number;

/**
 * Código de la moneda utilizada para el monto. Este valor es un string y se pasa como input desde el componente padre.
 * 
 * @type {string}
 */
@Input() currencyCode: string;

/**
 * Enum de `StatusBag` que se usa dentro del componente para acceder a los diferentes estados de la maleta.
 * 
 * @type {typeof StatusBag}
 */
StatusBag = StatusBag;
  constructor() { }

  ngOnInit(): void {
  }

}
